module.exports = __webpack_public_path__ + "assets/3ab377477438b2222e11de5c2143767f.mp3";